import React from 'react';
import { Space } from 'antd';
import styled from '@emotion/styled';
import { Title } from 'app/components/Typography/Title';
import Button from 'app/components/Button';

const StyledSpace = styled(Space)`
  width: 100%;
  justify-content: space-between;
`;

const ReportHeader = (props: {
  hideViewReport: boolean;
  onViewReport: () => void;
}) => {
  return (
    <StyledSpace align="center">
      <Title level={5}>Report </Title>
      <Space>
        <Button
          hidden={props.hideViewReport}
          type="primary"
          ghost
          onClick={props.onViewReport}
        >
          View Report
        </Button>
        {/* <Toolbar.MoreMenu
          actions={[
            // {
            //   label: 'Edit',
            //   key: 'edit',
            //   prefix: <EditOutlined />
            // },
            // {
            //   label: 'Duplicate',
            //   key: 'duplicate',
            //   prefix: <CopyOutlined />
            // },
            // {
            //   label: '',
            //   key: '',
            //   type: 'divider',
            //   extraProps: {
            //     style: { marginTop: 8, marginBottom: 8 }
            //   }
            // },
            {
              label: 'Delete',
              key: 'delete',
              type: undefined,
              prefix: <DeleteOutlined />,
              extraProps: {
                type: 'text',
                danger: true
              }
            }
          ]}
        ></Toolbar.MoreMenu> */}
      </Space>
    </StyledSpace>
  );
};

export default ReportHeader;
